/**
 * validateOverrides：校验应用覆写的 key 必须先在默认表中声明
 * 未声明的覆写直接报错，防止拼写错误导致的静默 bug
 *
 * 设计来源：yl-gbs-inf-sea-jms-front -> @pkg/diffconfig
 */
export function validateOverrides<T extends Record<string, unknown>>(
  moduleName: string,
  base: T,
  overrides: Record<string, unknown>
): void {
  const invalid = Object.keys(overrides || {}).filter((k) => !(k in base))
  if (invalid.length) {
    throw new Error(`[diffconfig/${moduleName}] override keys not declared in defaults -> ${invalid.join(', ')}`)
  }
}
